module.exports = __webpack_public_path__ + "img/dot-big-square.d683c004.svg";